import { Renderer2, RendererFactory2, Injectable } from '@angular/core';

@Injectable()
export class BodyBlock {
    private render: Renderer2;

    constructor(private factory: RendererFactory2) {
        this.render = factory.createRenderer(null, null);
    }

    blockBody(): void {
        this.render.setAttribute(document.body, 'aria-hidden', 'true');
    }

    unblockBody(): void {
        this.render.removeAttribute(document.body, 'aria-hidden');
    }
}
